import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystacabonrentinpune() {



  const cardData =
  {
    keyword: 'Innova Crysta Cab On Rent in Pune',
    heading: 'Sai Trupti Cabs: Innova Crysta Cab On Rent in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Innova Crysta on rent in Pune services, designed to make your city rides, group outings, corporate travel, and out-station journeys smooth and stress-free. Our fleet features well-maintained, air-conditioned Toyota Innova Crysta vehicles — all equipped with clean interiors, premium 6+1 or 7+1 seating configurations, and ample luggage space for your convenience. Every journey is managed by a professional, background-verified chauffeur who ensures punctual pickup anywhere in Pune, courteous service, and safe, smooth driving throughout your trip. With transparent rental rates and flexible booking options (hourly, daily, one-way drop, or round-trip), along with 24×7 customer support, Sai Trupti Cabs makes your Innova Crysta hire in Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the proud symbol of Pune’s Maratha heritage — once the seat of the mighty Peshwas. Built in 1732 by Bajirao I, this grand fort once housed royal courtyards, intricate teak pillars, fountains, and murals depicting scenes from the Mahabharata. Though much of it was destroyed by fire in 1828, its majestic gates and stone walls still echo the city’s golden era. The evening light-and-sound show narrates tales of bravery, politics, and romance that shaped Maratha history. Walking through its ancient arches, one can almost hear the voices of valor and legacy that define Pune’s soul."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a monument of peace, resilience, and patriotism. Built in 1892 by Sultan Aga Khan III, this graceful mansion became a part of India’s freedom struggle when Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Surrounded by lush gardens and Italian arches, the palace now serves as a museum preserving rare photographs, letters, and personal belongings of Gandhi. The tranquil ambiance invites visitors to reflect on India’s journey toward independence. Aga Khan Palace is not just an architectural gem but a shrine of history and sacrifice in Pune’s heart."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill about 30 km from Pune, Sinhagad Fort offers panoramic views of the Sahyadri ranges and the surrounding valleys. Once known as Kondhana, it witnessed the legendary battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors can trek to the fort’s summit, explore ancient ruins, and savor traditional snacks like pithla-bhakri from local stalls. The fort’s weathered walls still whisper tales of valor, loyalty, and Maratha pride. Whether for trekking, photography, or simply breathing in the mountain air, Sinhagad embodies Pune’s heroic and natural charm."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine carved out of basalt stone and dedicated to Lord Shiva. Hidden amidst the city’s bustle, this ancient temple is an oasis of calm and spirituality. Its circular Nandi pavilion, carved pillars, and echoing sanctum display exquisite craftsmanship from the Rashtrakuta era. The dimly lit interiors and rhythmic chants create an atmosphere that transcends time. As you step into the courtyard shaded by old banyan trees, the blend of faith and history feels almost tangible. Pataleshwar reminds visitors that Pune’s spiritual roots run deep beneath its modern skin."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, rising gracefully over Pune, combines scenic beauty with spiritual heritage. The temple complex at the summit — dedicated to Lord Shiva and Goddess Parvati — was built by the Peshwas and remains one of the city’s oldest landmarks. The climb of 108 stone steps rewards visitors with breathtaking views of the entire cityscape. Inside the temple, the air hums with devotion, while the surrounding breeze carries the aroma of incense. As the sun sets, the view from Parvati transforms into a golden panorama of old and new Pune. It’s a place where serenity meets history."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure chest of India’s artistic and cultural legacy. Curated by Dr. Dinkar Kelkar, it houses over 20,000 artifacts collected from across the country — from musical instruments and sculptures to jewelry, weapons, and handcrafted ornaments. The highlight is the recreated 'Mastani Mahal,' reflecting the elegance of Bajirao and Mastani’s era. Each artifact tells a story of creativity, craftsmanship, and everyday life in bygone centuries. For art lovers, it’s a journey through India’s soul; for Pune, it’s a proud reminder of its cultural depth."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for wellness, peace, and self-discovery. Spread over lush 28 acres, the resort features marble pathways, serene gardens, and modern meditation spaces surrounded by bamboo groves. Visitors from around the world come here to learn dynamic meditation and holistic healing practices. The Zen-like atmosphere and the fusion of nature with modern architecture make it a spiritual haven in the middle of an urban jungle. Whether for relaxation or transformation, Osho Ashram radiates calmness and international spiritual energy."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located just a short drive from Pune, is a beloved picnic and sunset spot surrounded by rolling hills. Built on the Mutha River, it is the city’s primary water source and a weekend retreat for locals. The shimmering water against the Sahyadri backdrop creates postcard-perfect views, especially during monsoon when the skies turn dramatic. Visitors enjoy roadside snacks, boating, and walks along the embankments. The cool breeze, golden sunsets, and reflection of clouds make it an ideal escape. Khadakwasla perfectly captures Pune’s balance of nature and modernity."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pu La Deshpande Udyan, also known as the Pune-Okayama Friendship Garden, is a symbol of Indo-Japanese harmony and aesthetic beauty. Modeled after Japan’s famous Korakuen Garden, it features landscaped lawns, small bridges, flowing streams, and stone paths amid lush greenery. Named after Marathi writer Pu La Deshpande, the garden offers peace and beauty in the middle of the city. Visitors enjoy serene walks, photography, and the tranquil charm of nature’s balance. It’s a perfect place to relax, reflect, and admire Pune’s cultural openness and ecological spirit."
  },
  {
    "title": "Dagadusheth Halwai Ganpati Temple",
    "description": "The Dagadusheth Halwai Ganpati Temple is one of Pune’s most sacred landmarks, attracting thousands of devotees daily. The temple’s magnificent Ganesha idol, adorned with gold and flowers, exudes grace and positivity. Founded more than a century ago by the sweet maker Dagadusheth Halwai, it has grown into a spiritual and cultural hub for Punekars. During Ganesh Chaturthi, the temple transforms into a dazzling sea of lights, music, and devotion. The rhythmic aarti and fragrance of incense fill the air, creating a divine atmosphere that defines the essence of Pune’s faith and festivity."
  }
],



"services": [
  {
    "name": "Innova Crysta Cab On Rent in Pune",
    "description": "Book comfortable Innova Crysta cabs on rent in Pune for a safe and hassle-free journey. Choose from AC and non-AC options with experienced drivers, flexible pickup and drop points, and transparent pricing. Perfect for family trips, group travel, or corporate journeys, with easy online booking and 24/7 support."
  },
  {
    "name": "Innova Crysta Taxi Pune",
    "description": "Hire an Innova Crysta taxi in Pune for a stress-free and comfortable ride. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options available with transparent fare policies."
  },
  {
    "name": "Innova Crysta Car Hire Pune",
    "description": "Rent an Innova Crysta in Pune for personalized and convenient travel. Enjoy AC/non-AC options, professional drivers, luggage assistance, and flexible routes. Ideal for family trips, group travel, or business journeys seeking comfort and reliability."
  },
  {
    "name": "AC Innova Crysta Pune",
    "description": "Travel comfortably with AC Innova Crysta cabs in Pune. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Perfect for families, couples, or solo travelers looking for a relaxed journey."
  },
  {
    "name": "Non AC Innova Crysta Pune",
    "description": "Affordable non-AC Innova Crysta cabs in Pune for budget-conscious travelers. Reliable drivers, well-maintained vehicles, and flexible pickup/drop points ensure safe and economical travel."
  },
  {
    "name": "Luxury Innova Crysta Pune",
    "description": "Travel in style with luxury Innova Crysta cabs in Pune. Premium interiors, AC service, and professional chauffeurs make it ideal for VIP guests, executives, or special occasions. Enjoy comfort, safety, and prestige throughout the ride."
  },
  {
    "name": "Affordable Innova Crysta Pune",
    "description": "Get pocket-friendly Innova Crysta cabs in Pune with transparent fares and flexible options. Reliable service, professional drivers, and easy booking make it perfect for solo travelers, students, and small families."
  },
  {
    "name": "Innova Crysta Outstation Cab Pune",
    "description": "Reliable outstation Innova Crysta cab service from Pune for weekend trips, sightseeing, or long stays. Enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for hassle-free interstate journeys."
  },
  {
    "name": "Innova Crysta One Way Cab Pune",
    "description": "Book one-way Innova Crysta cabs in Pune at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers without return plans."
  },
  {
    "name": "Innova Crysta Drop Cab Pune",
    "description": "One-way drop Innova Crysta cab service in Pune with flexible timings, AC/non-AC options, and professional drivers. Smooth, comfortable ride for transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Innova Crysta Pune",
    "description": "Premium corporate Innova Crysta cab hire in Pune with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events."
  },
  {
    "name": "Wedding Innova Crysta Pune",
    "description": "Elegant Innova Crysta cab service for weddings in Pune with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics."
  },
  {
    "name": "Online Innova Crysta Booking Pune",
    "description": "Book your Innova Crysta cab in Pune online with instant confirmation, secure payment, and transparent fares. Choose from AC and non-AC options for a convenient, stress-free journey."
  },
  {
    "name": "Best Innova Crysta Cab Pune",
    "description": "Experience the best Innova Crysta cab service in Pune with reliable vehicles, professional drivers, and flexible bookings. Perfect for families, groups, corporate travelers, and special occasions seeking comfort and convenience."
  }
],
"tableData": [
  ["Innova Crysta Cab On Rent in Pune", "Innova Crysta Taxi Pune"],
  ["Innova Crysta Car Hire Pune", "AC Innova Crysta Pune"],
  ["Non AC Innova Crysta Pune", "Luxury Innova Crysta Pune"],
  ["Affordable Innova Crysta Pune", "Innova Crysta Outstation Cab Pune"],
  ["Innova Crysta One Way Cab Pune", "Innova Crysta Drop Cab Pune"],
  ["Online Innova Crysta Booking Pune", "Corporate Innova Crysta Pune"],
  ["Wedding Innova Crysta Pune", "Best Innova Crysta Cab Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab on Rent in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs offers comfortable and premium Innova Crysta cab rental services in Pune — perfect for family trips, business travel, airport transfers, and outstation journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get affordable and transparent fares for Innova Crysta cabs on rent in Pune — no hidden charges, no surge pricing, and full value for your money."
  },
  {
    "WhyChooseheading": "Spacious & Premium Vehicle",
    "WhyChoosedescription": "Travel in a spacious 6+1 or 7+1 seater Innova Crysta, offering comfort, ample luggage space, and a smooth ride for short city trips or long outstation journeys."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are experienced with Pune city and nearby routes, ensuring a safe, smooth, and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from any location in Pune — airport, home, office, or railway station — and drop-offs at your desired destination."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains Innova Crysta vehicles that are clean, sanitized, and regularly serviced for a reliable and comfortable travel experience."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available 24/7 to assist with bookings, fare estimates, or any queries for your Innova Crysta cab rental in Pune."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Innova Crysta cab in Pune easily via call, WhatsApp, or our website — get instant confirmation and enjoy a stress-free journey."
  }
]

































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Innova Crysta cab on rent in Pune?',
    answer: 'Yes, Sai Trupti Cabs provides Innova Crysta cabs on rent in Pune for local trips, outstation travel, airport transfers, and sightseeing tours.',
  },
  {
    question: 'How can I book an Innova Crysta cab in Pune?',
    answer: 'You can book an Innova Crysta cab through our website, mobile app, or by contacting our 24×7 customer support for instant booking assistance.',
  },
  {
    question: 'What types of trips are available with Innova Crysta cab in Pune?',
    answer: 'Our Innova Crysta cabs can be booked for local travel, full-day sightseeing, airport transfers, and outstation trips across Maharashtra and nearby states.',
  },
  {
    question: 'Are the drivers experienced for Innova Crysta rentals?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced, ensuring a safe and comfortable journey with your Innova Crysta rental.',
  },
  {
    question: 'Can I hire an Innova Crysta cab for long-distance trips from Pune?',
    answer: 'Absolutely! Sai Trupti Cabs provides Innova Crysta cabs for long-distance trips across Maharashtra, including destinations like Lonavala, Satara, Shirdi, and Ujjain.',
  },
  {
    question: 'Is the Innova Crysta cab available 24×7 for rent?',
    answer: 'Yes, our Innova Crysta cab rental service operates 24×7 so you can book according to your convenience.',
  },
  {
    question: 'What are the charges for Innova Crysta cab rental in Pune?',
    answer: 'Our rental charges for Innova Crysta start from ₹1,200 for local hours and ₹3,000–₹6,500 for outstation trips, depending on distance and duration.',
  },
  {
    question: 'What payment options are available for Innova Crysta cab rental?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a secure and seamless transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Innova Crysta cabs?',
    answer: 'All Innova Crysta cabs are sanitized before each ride, and our drivers follow strict safety and hygiene protocols to ensure a safe journey.',
  },
  {
    question: 'Is customer support available during the Innova Crysta cab rental?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Innova Crysta cab rental.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Renting an Innova Crysta from Sai Trupti Cabs in Pune was a fantastic experience. The cab was comfortable and the driver very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Deshmukh',
    feedback: 'Excellent service! The Innova Crysta cab rental was smooth, punctual, and perfect for our Pune sightseeing trip.',
    rating: 5,
  },
];






























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Innova Crysta Cab On Rent in Pune",
  "image": "https://saitrupticabs.com/assets/images/innova-crysta-cab-pune.jpg", // Replace with actual image URL
  "description": "Rent an Innova Crysta in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // Example price, adjust according to actual rates
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/innova-crysta-cab-rent-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>Innova Crysta Cab On Rent in Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Rent an Innova Crysta in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, one-way trips, drop services, corporate travel, weddings, or outstation trips. Affordable 24x7 online booking available." 
  />
  <meta 
    name="keywords" 
    content="Innova Crysta Cab On Rent in Pune, Innova Crysta Taxi Pune, Innova Crysta Car Hire Pune, AC Innova Crysta Pune, Non AC Innova Crysta Pune, Luxury Innova Crysta Pune, Affordable Innova Crysta Pune, Innova Crysta Outstation Cab Pune, Innova Crysta One Way Cab Pune, Innova Crysta Drop Cab Pune, Corporate Innova Crysta Pune, Wedding Innova Crysta Pune, Online Innova Crysta Booking Pune, Best Innova Crysta Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystacabonrentinpune;